export default {"src":"/_next/static/media/laboratory-request-registration.184ee314.svg","height":169,"width":183,"blurWidth":0,"blurHeight":0};